import { Card, Icon, Pagination } from "@mui/material";
import { UserContext } from "App";
import UsersApi from "Classes/API/UsersApi";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useContext, useEffect, useState } from "react";
import DateTimePicker from "react-datetime-picker/dist/DateTimePicker";
import { useLocation, useNavigate } from "react-router-dom";
import AsyncSelect from "react-select/async";
import { LanguageContext } from "App";
import Swal from "sweetalert2";
import Loader from "Loader";
import SearchStringOrIntReq from "Classes/Models/Requests/SearchStringOrIntReq";
import AccountingApi from "Classes/API/AccountingApi";
import SearchUserModel from "Classes/Models/Requests/Users/SearchUser";
import GetAccountingSessionsEnteriesReq from "Classes/Models/Requests/AccountingSessions/GetAccountingSessionsEnteriesReq";
import { Check, Close } from "@mui/icons-material";

const PatientAccountingSessionEnteries = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  function handleOnClick(url) {
    navigate(url, { replace: true }), [navigate];
  }
  const { translations, switchLanguage } = useContext(LanguageContext);
  const [Page, setPage] = useState(1);
  const [PaginationPages, setPaginationPages] = useState(0);
  const [PatientSearch, setPatientSearch] = useState("");
  const [Patient, setPatient] = useState("");
  const [TherapistSearch, setTherapistSearch] = useState("");
  const [Therapist, setTherapist] = useState("");
  const [loading, setLoading] = useState(true);

  const loaderType = "balls";
  const loaderColor = "black";

  useEffect(async () => {
    await fetchAccountingSessionEnteries();
  }, [Page]);

  const User = useContext(UserContext);

  useEffect(() => {}, [Patient]);

  const GetPatients = async () => {
    let searchReq = new SearchUserModel();
    searchReq.userType = "Patient";
    searchReq.name = PatientSearch;

    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      console.log("GET PATIENTS: ", res);
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({
          value: item,
          label: item.name,
        });
      });

      return optionsArr;
    }
  };

  const getTherapists = async () => {
    let searchReq = new SearchUserModel();
    searchReq.userType = "Therapist";
    searchReq.name = TherapistSearch;

    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      console.log(res);
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({
          value: item,
          label: item.name,
        });
      });

      return optionsArr;
    }
  };

  const [TableDataRows, setTableDataRows] = useState([]);
  const RefreshTable = (resList) => {
    var rows = [];
    console.log(resList);
    resList.forEach((record) => {
      rows.push(MakeTableRow(record));
    });
    setTableDataRows(rows);
  };
  const TableColumns = [
    {
      Header: translations.appointmentPatientAccountingSessionEnteriesId,
      accessor: "AccountingSessionId",
      align: "left",
    },
    {
      Header: translations.appointmentPatientAccountingSessionEnteriesTherapistName,
      accessor: "TherapistName",
      align: "left",
    },
    {
      Header: translations.appointmentPatientAccountingSessionEnteriesPatientName,
      accessor: "PatientName",
      align: "left",
    },
    {
      Header: translations.appointmentPatientAccountingSessionEnteriesSession,
      accessor: "Session",
      align: "left",
    },
    {
      Header: translations.appointmentPatientAccountingSessionEnteriesAppointmentTime,
      accessor: "AppointmentDate",
      align: "left",
    },
    {
      Header: translations.appointmentPatientAccountingSessionEnteriesSessionNotes,
      accessor: "SessionNotes",
      align: "center",
    },
    {
      Header: translations.appointmentPatientAccountingSessionEnteriesPatientNotes,
      accessor: "PatientNotes",
      align: "center",
    },
  ];

  const MakeTableRow = (record) => {
    return {
      AccountingSessionId: (
        <MDTypography component="p" variant="button" color="dark">
          {record?.accountingSessionId}
        </MDTypography>
      ),
      TherapistName: (
        <MDTypography component="p" variant="button" color="dark">
          {record?.therapistName ? record.therapistName : "Not Registered"}
        </MDTypography>
      ),
      PatientName: (
        <MDTypography component="p" variant="button" color="dark">
          {record?.patientName}
        </MDTypography>
      ),
      Session: (
        <MDTypography component="p" variant="button" color="dark">
          {record?.sessionName}
        </MDTypography>
      ),
      AppointmentDate: (
        <MDTypography component="p" variant="button" color="dark">
          {new Date(record?.appointmentDate).toLocaleTimeString()}
        </MDTypography>
      ),
      SessionNotes: (
        <MDTypography component="p" variant="button" color="dark">
          {record?.hasSessionHistoryEntry ? <Check /> : <Close />}
        </MDTypography>
      ),
      PatientNotes: (
        <MDTypography component="p" variant="button" color="dark">
          {record?.hasPatientHistoryEntry ? <Check /> : <Close />}
        </MDTypography>
      ),
    };
  };

  const fetchAccountingSessionEnteries = async () => {
    try {
      if (!loading) {
        setLoading(true);
      }
      let req = new GetAccountingSessionsEnteriesReq();
      console.log("Appday: ", req);
      req.SearchDate = new Date(state.AppDay.dateDay);
      req.SearchDate.setHours(12, 0, 0, 0);
      req.DayId = state.AppDay.id;
      req.TherapistId = Therapist?.id;
      req.PatientId = Patient?.id;
      req.pagingParams.pageNumber = Page;
      req.pagingParams.pageSize = 10;

      const res = await AccountingApi.FindAccountingSessionPatientEnteries(req);
      console.log("res", res);
      if (res && res.status === "Success") {
        const list = res.data?.list ?? [];
        RefreshTable(list);
        setPaginationPages(res.data?.totalPages ?? 0);
      } else {
        console.error('Error: API response status not "Success"');
        setPaginationPages(0);
      }
    } catch (error) {
      console.error("Error fetching patient data:", error);
      setPaginationPages(0);
    } finally {
      setLoading(false);
    }
  };

  const clearFilter = async () => {
    setPatient("");
    setTherapist("");
    //await fetchAccountingSessionEnteries()
    location.reload();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card mb={3} id="SearchUsers">
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6" fontWeight="medium">
            {translations.appointmentPatientAccountingSessionEnteriesFilterAccountingSessionsby}
          </MDTypography>
          <MDButton
            onClick={() => clearFilter()}
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="info"
          >
            <Icon sx={{ fontWeight: "bold" }}>search</Icon>
            &nbsp;{translations.appointmentPatientAccountingSessionEnteriesClearFilters}
          </MDButton>
        </MDBox>

        <form id="SearchUsersForm">
          <MDBox p={3}>
            <MDBox
              borderRadius="lg"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={2}
            >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-4 ">
                    <MDTypography
                      className="col-md-4"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                    >
                      <AsyncSelect
                        isClearable={true}
                        placeholder={
                          translations.appointmentPatientAccountingSessionEnteriesSelectbytherapistname
                        }
                        loadOptions={getTherapists}
                        onInputChange={setTherapistSearch}
                        // onChange={(e) => setName(e ? e.value : "")}
                        onChange={(e) => setTherapist(e ? e.value : "")}
                      />
                    </MDTypography>
                  </div>
                  <div className="col-md-4 ">
                    <MDTypography
                      className="col-md-4"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                    >
                      <AsyncSelect
                        isClearable={true}
                        placeholder={
                          translations.appointmentPatientAccountingSessionEnteriesSelectbypatientname
                        }
                        loadOptions={GetPatients}
                        onInputChange={setPatientSearch}
                        // onChange={(e) => setName(e ? e.value : "")}
                        onChange={(e) => setPatient(e ? e.value : "")}
                      />
                    </MDTypography>
                  </div>
                  <div className="col-md-4 align-content-center">
                    <MDButton
                      onClick={() => fetchAccountingSessionEnteries()}
                      sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                      color="info"
                    >
                      <Icon sx={{ fontWeight: "bold" }}>search</Icon>
                      &nbsp;
                      {
                        translations.appointmentPatientAccountingSessionEnteriesSearchAccountingSessions
                      }
                    </MDButton>
                  </div>
                </div>
              </div>
            </MDBox>
          </MDBox>
        </form>
      </Card>
      {loading ? (
        <Loader type="balls" color="black" />
      ) : (
        <Card className="mt-5">
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            sx={{ backgroundColor: "#3560AD" }}
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
            textAlign="center"
          >
            <MDTypography variant="h6" color="white">
              {new Date(state.AppDay.dateDay).toDateString()}{" "}
              {
                translations.appointmentPatientAccountingSessionEnteriesSearchAccountingSessionsheader
              }
            </MDTypography>
          </MDBox>

          <MDBox pt={3}>
            <DataTable
              table={{ columns: TableColumns, rows: TableDataRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
          </MDBox>

          <div className="text-right mx-3 my-4">
            <Pagination
              count={PaginationPages}
              page={Page}
              color="primary"
              onChange={(e, number) => setPage(number)}
              className="float-right"
            />
          </div>
        </Card>
      )}
    </DashboardLayout>
  );
};

export default PatientAccountingSessionEnteries;
